module.exports = __webpack_public_path__ + "static/media/iitblaunch.9e1e42f8.png";